<template>
  <div id="enterprise-contact">
    <!-- 联系方式 -->
    <div class="enterprise-contact-type">
      <!-- 自主创建联系人 -->
      <div
        class="enterprise-contact-item"
        id="自主创建联系人"
        v-if="clientInfo && clientInfo.id"
      >
        <div class="enterprise-contact-item-title">
          <div>
            自主创建联系人 ({{ selfCreatedInformation.tableData.length }})
          </div>
          <div>
            <el-button
              type="primary"
              plain
              size="mini"
              v-showFunction="{
                active: 'createContact',
                array: allFunctionButtons,
              }"
              @click="handleClick({}, '', 'create')"
              >新增联系人</el-button
            >
          </div>
        </div>
        <div class="enterprise-contact-item-value">
          <enterpriseCard7
            :clientInfo="clientInfo"
            :information="selfCreatedInformation"
            :allFunctionButtons="allFunctionButtons"
            @handleClick="handleClick"
            @onCopy="onCopy"
          >
          </enterpriseCard7>
        </div>
      </div>
      <template>
        <!-- 公司联系方式 -->
        <div class="enterprise-contact-item" id="公司联系方式">
          <div class="enterprise-contact-item-title">
            公司联系方式 ({{ companyContactInformation.pageData.totalCount }})
          </div>
          <div class="enterprise-contact-item-value">
            <div class="tab-card">
              <div class="tab-list">
                <el-tabs v-model="activeName" @tab-click="changeTab">
                  <el-tab-pane
                    :label="item.label"
                    :name="item.active"
                    v-for="(item, index) in tabList"
                    :key="index"
                  >
                    <enterpriseCard2
                      :information="companyContactInformation"
                      @handleCurrentChange="handleCurrentChange"
                      v-if="activeName == 'mobile'"
                    >
                      <template v-slot:title>
                        <div class="enterprise-card2-search">
                          <div>
                            <el-checkbox
                              v-model="checkList.onlyKp"
                              @change="getCompanyContactInformation"
                              >kp联系人</el-checkbox
                            >
                            <!-- <el-checkbox v-model="checkList">有微信</el-checkbox> -->
                            <!-- <el-checkbox
                            v-model="checkList.phoneTag"
                            @change="getCompanyContactInformation"
                            >剔除空号/沉默号/风险号</el-checkbox
                          > -->
                            <!-- <el-checkbox v-model="checkList">近期收录</el-checkbox> -->
                          </div>
                          <div>
                            <el-input
                              v-model="value"
                              placeholder="请输入姓名、岗位"
                            ></el-input>
                          </div>
                        </div>
                      </template>
                      <template v-slot:content>
                        <enterpriseCard3
                          :information="companyContactInformation"
                        />
                      </template>
                    </enterpriseCard2>
                    <enterpriseCard2
                      :information="companyContactInformation"
                      @handleCurrentChange="handleCurrentChange"
                      v-if="activeName == 'tel'"
                    >
                      <template v-slot:title></template>
                      <template v-slot:content>
                        <enterpriseCard3
                          :information="companyContactInformation"
                        />
                      </template>
                    </enterpriseCard2>
                    <enterpriseCard2
                      :information="companyContactInformation"
                      @handleCurrentChange="handleCurrentChange"
                      v-if="activeName == 'emil'"
                    >
                      <template v-slot:content>
                        <enterpriseCard4 :companyEmilList="companyEmilList" />
                      </template>
                    </enterpriseCard2>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
        <!-- 关联联系方式 -->
        <div class="enterprise-contact-item" id="关联联系方式">
          <div class="enterprise-contact-item-title">
            关联联系方式
          </div>
          <div class="enterprise-contact-item-value">
            <enterpriseCard2
              :information="correlationInformation"
              @handleCurrentChange="handleCurrentChange"
            >
              <template v-slot:content>
                <enterpriseCard3 :information="correlationInformation" />
              </template>
            </enterpriseCard2>
          </div>
        </div>
        <!-- 疑似联系人 -->
        <div class="enterprise-contact-item" id="疑似联系人">
          <div class="enterprise-contact-item-title">
            <!-- 疑似联系人 -->
          </div>
          <div class="enterprise-contact-item-value"></div>
        </div>
        <!-- 人脉 -->
        <div class="enterprise-contact-item" id="人脉">
          <div class="enterprise-contact-item-title">
            <!-- 人脉 -->
          </div>
          <div class="enterprise-contact-item-value"></div>
        </div>
        <!-- 团队 -->
        <div class="enterprise-contact-item" id="团队">
          <div class="enterprise-contact-item-title">
            <!-- 团队 -->
          </div>
          <div class="enterprise-contact-item-value"></div>
        </div>
      </template>
      <!-- <template v-else>
        <el-empty description="暂无数据"></el-empty>
      </template> -->
    </div>
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog
        :width="dialogData.width"
        :title="dialogData.title"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
        @buttonOper="drawerOper"
      ></my_dialog>
    </div>
  </div>
</template>

<script>
import enterpriseCard2 from "@/components/enterprise-components/enterprise-card2";
import enterpriseCard3 from "@/components/enterprise-components/enterprise-card3";
import enterpriseCard4 from "@/components/enterprise-components/enterprise-card4";
import enterpriseCard7 from "@/components/enterprise-components/enterprise-card7";
import { title } from "process";
export default {
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    enterpriseCard2,
    enterpriseCard3,
    enterpriseCard4,
    enterpriseCard7,
    my_dialog: () => import("@/components/dialog.vue"),
  },
  data() {
    return {
      baseInfo: {},
      dialogData: {
        flag: false,
        width: "45%",
        title: "新建报销",
        buttonArray: [
          {
            text: "提交",
            active: "submit_gnjinjilu",
          },
        ],
        data: [],
      },
      value: "",
      activeName: "mobile",
      tabList: [
        {
          label: "手机",
          active: "mobile",
        },
        {
          label: "固话",
          active: "tel",
        },
        {
          label: "邮箱",
          active: "emil",
        },
      ],
      checkList: {
        onlyKp: false,
        phoneTag: true,
      },
      companyContactInformation: {
        activeName: "mobile",
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 6,
          totalCount: 0,
        },
      },
      companyEmilList: [], // 邮箱
      correlationInformation: {
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 6,
          totalCount: 0,
        },
      }, // 关联联系方式
      selfCreatedInformation: {
        tableData: [],
      }, // 自主创建联系人
      allFunctionButtons: this.$featureData.getAllFunctionButtons("clientInfo"),
      tagList: {}, // 标签组
      tempData: {},
    };
  },
  watch: {
    "tabActive.tab2Active": {
      handler(newValue, oldValue) {
        // tabActive.tab3Active 变化时 页面滑动到对应区域
        this.$nextTick(() => {
          document
            .getElementById(newValue)
            .scrollIntoView({ behavior: "smooth" });
        });
      },
    },
  },
  methods: {
    getModelFeatureAuthority() {
      this.$authority.getModelFeatureAuthority(
        this,
        "clientInfo",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
          this.$tagData.getTagList(
            this.tagList,
            ["联系人职位"],
            this.baseInfo.company.companyId,
            this,
          );
          console.log("this.tagList", this.tagList);
        },
      );
    },
    // 自主创建联系人
    getSelfCreatedInformation() {
      let requestData = {
        clientId: this.clientInfo.id,
        companyId: this.baseInfo.company.companyId,
        userId: this.baseInfo.userId,
      };
      this.$request(
        "post",
        "/client/showClientContactByID",
        requestData,
        (data) => {
          this.selfCreatedInformation.tableData = data;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 企业联系电话
    getCompanyContactInformation() {
      let requestData = {
        type: this.activeName, // 号码类型 空全部/mobile 手机号/tel 固话
        onlyKp: this.checkList.onlyKp, // 是否仅查看 kp 号码； false 为不限制
        phoneTag: this.checkList.phoneTag, // 是否返回号码检测标签；false 为不返回
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.companyContactInformation.pageData.pageIndex,
        pageSize: this.companyContactInformation.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_2041",
        requestData,
        (data) => {
          this.companyContactInformation.tableData =
            data.entInfo.pagerContact.data;

          this.companyContactInformation.pageData = {
            pageIndex: data.entInfo.pagerContact.pageIndex,
            pageSize: data.entInfo.pagerContact.pageSize,
            totalCount: data.entInfo.pagerContact.totalCount,
          };
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 企业邮箱列表
    getCompanyEmilList() {
      this.$request(
        "get",
        "/xiaoLanBen/api_2080?eid=" + this.enterpriseInfo.base.eid,
        {},
        (data) => {
          if (data.entInfo.homePage && data.entInfo.homePage.emailAgg) {
            this.companyEmilList = data.entInfo.homePage.emailAgg;
            this.companyContactInformation.pageData.totalCount =
              data.entInfo.homePage.emailAgg.length;
          }
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 关联联系方式
    getCorrelationInformation() {
      let requestData = {
        phoneTag: this.checkList.phoneTag, // 是否返回号码检测标签；false 为不返回
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.correlationInformation.pageData.pageIndex,
        pageSize: this.correlationInformation.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_2051",
        requestData,
        (data) => {
          this.correlationInformation.tableData =
            data.entInfo.pagerRelationContact.data;

          this.correlationInformation.pageData = {
            pageIndex: data.entInfo.pagerRelationContact.pageIndex,
            pageSize: data.entInfo.pagerRelationContact.pageSize,
            totalCount: data.entInfo.pagerRelationContact.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "关联联系方式",
            tab3Active: "",
            count: this.correlationInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    changeTab() {
      this.companyContactInformation.activeName = this.activeName;
      if (this.activeName == "mobile" || this.activeName == "tel") {
        this.companyContactInformation.pageData = {
          pageIndex: 1,
          pageSize: 6,
          totalCount: 0,
        };
        this.getCompanyContactInformation();
      } else if (this.activeName == "emil") {
        this.getCompanyEmilList();
      }
    },
    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(table) {
      this.companyContactInformation.pageData = table.pageData;
      this.getCompanyContactInformation();
    },
    // 自主创建联系人操作
    handleClick(item, index, flag) {
      this.tempData = item;
      console.log("this.tempData", this.tempData);
      this.tempData.index = index;
      switch (flag) {
        // 新增
        case "create":
          this.dialogData.title = "新增联系人";
          this.dialogData.width = "500px";
          this.dialogData.buttonArray = [
            {
              text: "确定",
              active: "sure_add",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "姓名",
              type: "input",
              key: "name",
              value: "",
              required: true,
            },
            {
              title: "职位",
              type: "select",
              key: "position",
              value: "",
              options: this.tagList.contactPositionList,
              required: true,
            },
            {
              title: "手机号",
              type: "input",
              key: "phone",
              value: "",
              required: true,
            },
          ];
          this.dialogData.flag = true;
          break;
        // 编辑
        case "edit":
          this.dialogData.title = "编辑联系人";
          this.dialogData.width = "500px";
          this.dialogData.buttonArray = [
            {
              text: "确定",
              active: "sure_edit",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "姓名",
              type: "input",
              key: "name",
              value: item.name,
              required: true,
            },
            {
              title: "职位",
              type: "select",
              key: "position",
              value: item.position,
              options: this.tagList.contactPositionList,
              required: true,
            },
            {
              title: "手机号",
              type: "input",
              key: "phone",
              value: item.phone,
              required: true,
            },
          ];
          this.dialogData.flag = true;
          break;
        // 删除
        case "delete":
          this.$confirm("确认删除当前联系人信息吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let requestData = {
                clientId: this.clientInfo.id, // 客户id
                data: this.selfCreatedInformation.tableData,
              };
              requestData.data.splice(index, 1);
              this.asd9(requestData);
            })
            .catch(() => {});
          break;
        default:
          break;
      }
    },
    drawerOper(active) {
      let requestData = {};
      let flag = false;
      let numberFlag = false;
      switch (active) {
        case "makesure_add_contact":
          this.getContactList();
          break;
        // 确认添加联系人
        case "sure_add":
          requestData = {
            clientId: this.clientInfo.id, // 客户id
            data: [
              ...this.selfCreatedInformation.tableData,
              {
                name: this.dialogData.data[0].value,
                position: this.dialogData.data[1].value,
                phone: this.dialogData.data[2].value,
                createUserId: this.baseInfo.userId, // 创建人
                createUserName: this.baseInfo.userName, // 创建人姓名
                createTime: this.$dayjs().format("YYYY-MM-DD HH:mm:ss"), // 创建时间
              },
            ],
          };
          requestData.data.forEach((item) => {
            if (!item.name || !item.position || !item.phone) flag = true;
          });
          if (flag) return this.$message.error("请将必填信息填写完整!");
          this.asd9(requestData);
          break;
        // 确认编辑联系人
        case "sure_edit":
          requestData = {
            clientId: this.clientInfo.id, // 客户id
            data: [...this.selfCreatedInformation.tableData],
          };
          requestData.data[this.tempData.index] = {
            name: this.dialogData.data[0].value,
            position: this.dialogData.data[1].value,
            phone: this.dialogData.data[2].value,
            createUserId: this.tempData.createUserId, // 创建人
            createUserName: this.tempData.createUserName, // 创建人姓名
            createTime: this.tempData.createTime, // 创建时间
          };
          requestData.data.forEach((item) => {
            if (!item.name || !item.position || !item.phone) flag = true;
            if (this.$phoneCheck.mobilePhoneNumberCheck(item.phone)) {
              numberFlag = true;
            }
          });
          if (flag) return this.$message.error("请将必填信息填写完整!");
          this.asd9(requestData);
          break;
        case "cancel":
          this.dialogData.flag = false;
          break;
        default:
          break;
      }
    },
    asd9(requestData) {
      this.$request(
        "post",
        "/client/updateClientContactByID",
        requestData,
        (data) => {
          this.$message.success("操作成功!");
          this.getSelfCreatedInformation();
          this.dialogData.flag = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    getContactList() {
      let requestData = {
        clientId: this.clientInfo.id, // 客户id
        userId: this.baseInfo.userId,
        companyId: this.baseInfo.company.companyId,
      };
      this.$request(
        "post",
        "/client/showClientContactByID",
        requestData,
        (data) => {
          this.dialogData.data.forEach((item) => {
            requestData[item.key] = item.value;
          });
          if (!this.$phoneCheck.mobilePhoneNumberCheck(requestData.phone)) {
            // 做手机号格式校验
            this.$message.error("联系人电话格式不正确,请确认填入正确的电话!");
            return;
          }
          data.push(requestData);
          console.log("data", data);
          let requestData2 = {
            clientId: this.clientInfo.id, // 客户id
            data: data,
          };
          this.$request(
            "post",
            "/client/updateClientContactByID",
            requestData2,
            (data) => {
              this.$message.success("客户联系人添加成功!");
              this.dialogData.flag = false;
              this.$operationRecords.saveOperationRecords(
                this.clientInfo.id,
                "客户联系人基本信息修改!",
                this.baseInfo,
                "client",
                this,
                (data2) => {},
              );
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    onCopy(item) {
      let requestData = {
        userId: this.baseInfo.userId,
        // date: this.$formatTime(new Date(), "YYYY-MM-DD HH:mm:ss"), // 时间
        date: this.$dayjs().format("YYYY-MM-DD HH:mm:ss"), // 时间
        copyContent: item.phone, // 复制内容
        count: 1, // 复制次数,
        copyModule: "客户",
        name: this.enterpriseInfo.base.entname, // 客户名称
      };
      this.$request(
        "post",
        "/copyListening/add",
        requestData,
        (data) => {},
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    console.log("tabActive", this.tabActive);
    this.getModelFeatureAuthority();
    this.getSelfCreatedInformation();
    if (this.enterpriseInfo.base && this.enterpriseInfo.base.eid) {
      this.getCompanyContactInformation();
      this.getCorrelationInformation();
    }
  },
};
</script>

<style lang="less">
#enterprise-contact {
  width: 100%;
  background-color: #fff;
  .enterprise-contact-type {
    width: 100%;
    .enterprise-contact-item {
      width: 100%;
      margin-top: 32px;
      &:first-child {
        margin-top: 0;
      }
      /deep/ .el-input__inner {
        width: auto !important;
        border: 1px solid #dcdfe6;
      }
      .enterprise-contact-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
      }
      .enterprise-contact-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .enterprise-contact-item-value {
        width: 100%;
        .text {
          width: 100%;
          padding: 15px 23px;
          font-size: 14px;
          line-height: 24px;
          text-align: left;
          box-sizing: border-box;
          background: #f6f8fb
            url(https://51nbimg.u51.com/62c9ea111656463a90e8c968177a5d5d.png)
            right bottom / 102px 102px no-repeat;
        }
        .table-text {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .table-text-item {
            width: 100%;
            height: 100%;
            display: flex;
            font-size: 14px;
            border: 1px solid #eff1f8;
            color: #111a34;

            .table-text-item-title {
              background-color: #f9fafc;
              width: 145px;
              min-width: 145px;
              text-align: right;
              padding: 13px 16px;
              box-sizing: border-box;
              color: #777e95;
              border-right: 1px solid #eff1f8;
            }
            .table-text-item-value {
              width: 80%;
              padding: 13px 16px;
              box-sizing: border-box;
              text-align: left;
              word-wrap: break-word;
              word-break: normal;
            }
          }
          .gather {
            .table-text-item-line {
              display: flex;
              &:last-child .table-text-item-value {
                border-bottom: 0;
              }
              .table-text-item-value {
                border-right: 1px solid #eff1f8;
                border-bottom: 1px solid #eff1f8;
                &:nth-child(even) {
                  border-right: 0;
                }
              }
            }
          }
        }
        .tab-card {
          .tab-list {
            .enterprise-card2-search {
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin: 12px 0;
            }
            .enterprise-card2-content {
            }
          }
        }
      }
    }
  }
}
</style>
